var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"size":"xl","id":"pdfmodel","title":"Referto"},on:{"click":function($event){return _vm.onClickPdf()}}},[[_c('b-embed',{attrs:{"type":"iframe","src":_vm.pdf,"allowfullscreen":""}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }